import React, { forwardRef } from 'react';

/**
 * RadioGroup - Componente para grupo de radio buttons
 *
 * Props:
 * - label: Texto del label del grupo
 * - options: Array de objetos { value: string, label: string }
 * - value: Valor actual seleccionado
 * - onChange: Función callback cuando cambia la selección (value) => void
 * - error: Mensaje de error (opcional)
 * - required: Indica si el campo es requerido (opcional)
 * - className: Clases CSS adicionales (opcional)
 */
const RadioGroup = forwardRef(({
  label,
  options,
  value,
  onChange,
  error,
  required = false,
  className = ''
}, ref) => {
  return (
    <div ref={ref} className={`mb-3 ${className}`}>
      <label className="form-label fw-medium">
        {label}
        {required && <span className="text-danger">*</span>}
      </label>
      <div className="d-flex gap-3">
        {options.map((option) => (
          <div key={option.value} className="form-check">
            <input
              type="radio"
              value={option.value}
              checked={value === option.value}
              onChange={(e) => onChange(e.target.value)}
              className="form-check-input"
              id={`radio-${option.value}`}
            />
            <label className="form-check-label" htmlFor={`radio-${option.value}`}>
              {option.label}
            </label>
          </div>
        ))}
      </div>
      {error && (
        <div className="text-danger small mt-1">{error}</div>
      )}
    </div>
  );
});

RadioGroup.displayName = 'RadioGroup';

export default RadioGroup;
